import { render, staticRenderFns } from "./AddonEdit.vue?vue&type=template&id=50f7d132&"
import script from "./AddonEdit.vue?vue&type=script&lang=js&"
export * from "./AddonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports